import { useAxiosProvider } from "../components/AxiosProvider.js";
import { ActiveCodeType, AnamnesisCodeMedium, AnamnesisCodeReason, AnamnesisCodeCreatorApplication } from "../patient-today-list.types.js";
import { useMutation } from "@tanstack/react-query";
import "react/jsx-runtime";
import "react";
import "axios";
const generateCode = (axios) => async (patientReferenceId) => {
  const { data } = await axios.post(`api/internal/patients/${patientReferenceId}/codes`, {
    type: ActiveCodeType.SHORT,
    sentMedium: AnamnesisCodeMedium.CLINIC,
    sentReason: AnamnesisCodeReason.CLINIC_TRIGGERED,
    creatorApplication: AnamnesisCodeCreatorApplication.CALMASTER_FRONTEND
  });
  return data;
};
const useGenerateAnamnesisCode = (options) => {
  const { ana } = useAxiosProvider();
  return useMutation(generateCode(ana), {
    onSuccess: () => {
      var _a;
      return (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options);
    },
    onError: () => {
      var _a;
      return (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options);
    }
  });
};
export {
  useGenerateAnamnesisCode
};
